import { SectionData } from '../../../types'
import { BaseNode } from '../..'

export class SectionNode extends BaseNode {
  declare data: SectionData

  public getLabelTemplate(): string {
    return this.data.name
  }
}
